module.exports = __webpack_public_path__ + "img/playStore.02d97d1d.png";